import { FormLabel, MenuList, Radio } from '@mui/material';
import React, { FC, useId } from 'react';

import { MESSAGE_STATUS_TRANSLATION_KEY } from '../../../../constants/message';
import { MessageStatus } from '../../../../generated/graphql';
import translate from '../../../../i18n/translate';

import * as Styled from './styled';

type Props = {
  currentStatus: MessageStatus;
  onStatusChange: (status: MessageStatus) => void;
};

/**
 * Status selection for compose section
 *
 * @param props                Props passed to the component
 * @param props.currentStatus  Currently selected status
 * @param props.onStatusChange Request that selected status is changed
 *
 * @returns                    Component itself
 */
const ComposeStatusSelection: FC<Props> = ({
  currentStatus,
  onStatusChange,
}) => {
  const statusSelectionId = useId();

  return (
    <Styled.StyledFormControl>
      <FormLabel id={statusSelectionId}>
        {translate('TASK__CHANGE_STATUS')}
      </FormLabel>
      <MenuList aria-labelledby={statusSelectionId}>
        {Object.values(MessageStatus).map(status => {
          const label = translate(MESSAGE_STATUS_TRANSLATION_KEY[status]);
          const selected = currentStatus === status;

          return (
            <Styled.StatusListItem
              key={status}
              onClick={() => onStatusChange(status)}
              selected={selected}
            >
              <Radio
                checked={selected}
                disableFocusRipple={true}
                inputProps={{ 'aria-label': label }}
                size="small"
                tabIndex={-1}
              />
              {label}
            </Styled.StatusListItem>
          );
        })}
      </MenuList>
    </Styled.StyledFormControl>
  );
};

export default ComposeStatusSelection;
